import { createStyles, makeStyles } from '@material-ui/core';

const TOP = '15em';

const useVisionStyles = makeStyles((theme) =>
    createStyles({
        contentGrid: {
            maxWidth: 1500
        },
        contentContainer: {
            marginTop: TOP,
            marginBottom: '20em',
            marginLeft: '5em',
            width: '30vw',
            maxWidth: 700,
            zIndex: 10,
            position: 'relative',
            [theme.breakpoints.down('sm')]: {
                width: 'auto',
                marginLeft: '1em'
            }
        },
        video: {
            top: '10em'
        },
        content: { marginBottom: '5em' },
        liContent: { marginBottom: '2em' },
        rowContent: { display: 'flex', alignItems: 'flex-end' },
        centerContent: { display: 'flex', flexDirection: 'column', alignItems: 'center' },

        shallowContent: {
            width: '30%',
            [theme.breakpoints.down('md')]: {
                width: '50%'
            }
        },
        puzzle: { width: '30%' },
        centerPuzzle: { marginTop: theme.spacing(2), transform: 'translateX(-48px)' },
        title: {
            fontWeight: 500,
            position: 'fixed',
            top: '8em',
            left: '3em',
            [theme.breakpoints.down('sm')]: {
                position: 'static',
                marginTop: '5em',
                marginLeft: '1em'
            }
        },
        fakeTitle: { marginLeft: '3em' },
        
        hide: { visibility: 'hidden', [theme.breakpoints.down('sm')]: { display: 'none' } }
    })
);

export default useVisionStyles;
